import React, { useMemo } from "react";
import aboutFront from "../assets/Vector 73 (1).svg";
import { coreTeam } from "./OurTeam";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useEffect } from "react";
const MemberDetails = () => {
  const location = useLocation();
  const { id } = location.state || {};

  const user = useMemo(() => {
    return coreTeam.find((m) => m.id === id) || {};
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0); // Page ko top-left pe scroll karne ke liye
  }, [id]); // Y

  return (
    <>
      <div className="container core">
        <div className="core-image position-relative">
          <img src={aboutFront} alt="Our Team" style={{ objectFit: "cover" }} />
          <h4 className="centered">Our Team And Board Advisory</h4>
          <div className="team mb-0">
            <h3 className="text-center mb-0">Our Team</h3>
          </div>
        </div>

        <div className="row core-name mt-5 mb-5">
          <div className="col-lg-4 mt-3">
            <img src={user.image} alt="Mahendra Khandelwal" />
          </div>
          <div className="col-lg-8 mt-2">
            <h3>{user.name}</h3>
            <span className="pt-3">{user.title}</span>
            <p className="my-4">{user.desc}</p>
          </div>
        </div>

        <div className="row biography"></div>
      </div>
      <div className="container-fluid members">
        <div className="row">
          <h2 className="text-center fw-bolder mb-4">Our Team Members</h2>
          {coreTeam.map((member, index) => (
            <div className="col-lg-3 col-md-6 core-team1 mb-4">
              <Link to={"/core1:id"} key={index} state={{ id: member.id }}>
                <img className="member" src={member.image} alt="Team Member" />
                <h5 className="text-center mt-3 mb-0">{member.name}</h5>
                <p className="text-center mb-0">{member.title}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MemberDetails;
